(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/track/telephone/telephone.tpl.html',
    '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12 mainContent" style="padding: 2px"><div ui-view="list" ng-show="$state.includes(\'telephones.list\')"></div><div ui-view="edit" ng-show="$state.includes(\'telephones.edit\')"></div><div ui-view="new" ng-show="$state.includes(\'telephones.new\')"></div><div ui-view="copy" ng-show="$state.includes(\'telephones.copy\')"></div></div></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/telephone.tpl.js